import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SolicitacaoAuxSaudeService } from '../../service/solicitacao-aux-saude/solicitacao-aux-saude.service';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { Pendencia, TipoSolicitacao } from "app/model/solicitacaoAuxSaude";
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-solicitacao-auxilio-saude',
  templateUrl: './solicitacao-auxilio-saude.component.html',
  styleUrls: ['./solicitacao-auxilio-saude.component.sass']
})
export class SolicitacaoAuxilioSaudeComponent implements OnInit {
  form: FormGroup = null;
  listaTipoSolicitacao: TipoSolicitacao[] = [];
  listaRequisicaoValidada: boolean = false;
  permiteEdicao: boolean = false;
  visualizar: boolean = false
  solicitacaoId: number = null;
  exibirTipoSolicitacao: boolean = false;
  isInfoImportantVisible: boolean = true;
  pendencia: Pendencia = new Pendencia();

  steps: Array<{ status: string, complete: boolean}> = [];
  currentStepIndex = null;

  constructor(
    private formBuilder: FormBuilder,
    private solicitacaoAuxSaudeService: SolicitacaoAuxSaudeService,
    private toasterService: ToastrService,
    private location: Location,
    private route: ActivatedRoute,
    private _formBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.solicitacaoId = this.extractIdFromUrl();
    this.createForm();
    if(this.solicitacaoId){
      this.editarVisualizar()
    }
    else{
      this.permissaoLoad()
    }
  }

  toggleInfoImportantVisible() {
    this.isInfoImportantVisible = !this.isInfoImportantVisible;
  }

  extractIdFromUrl(): number {
    return this.route.snapshot.params.id ?? null;
  }

  editarVisualizar(){

    this.solicitacaoAuxSaudeService.getListarAdamento(this.solicitacaoId).subscribe( resp => {
      this.steps = resp;
      this.currentStepIndex = this.steps.findIndex( s => !s.complete )-1;
    })

    this.solicitacaoAuxSaudeService.getEditarVisualizar(this.solicitacaoId).subscribe((result) => {

      this.solicitacaoAuxSaudeService.getMotivoRecusa(this.solicitacaoId).subscribe( resp => {
        this.pendencia = resp
      })
      this.permiteEdicao = result.permiteEdicao
      if(!this.permiteEdicao){
        this.visualizar = true;
      }
      this.loadDados()
    }, error => {
      this.toasterService.error(error.error.message)
    })
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      //Dados Pessoais
      nome: [{ value: null, disabled: true }],
      cargo: [{ value: null, disabled: true }],
      vinculo: [{ value: null, disabled: true }],
      telefone: [{ value: null, disabled: true }],
      celular: [{ value: null, disabled: true }],
      cpf: [null],
      dataNascimento: [null],
      //Tipo de Solicitação
      tipoSolicitacao: [null],
      dependente: [false],
      tipoPlano: [null],
      nomePlano: [null],
      idPlano: [null],
      valorPlano: [null],
      //Dependente
      idDependente: [null],
      cpfDependente: [null],
      nomeDependente: [null],
      dataNascimentoDependente: [null],
      tipoParentesco: [null],
      declaroSim: [false],
      sexo: [null],
      estadoCivil: [null],
      tipoCapacidade: [null],
      dataInvalidez: [null],
    });
  }

  permissaoLoad() {
    this.solicitacaoAuxSaudeService.getPermitePreencher().subscribe((result) => {
      if (result) {
        this.loadDados()
      }
      else {
        this.toasterService.error("Usuário não possui permissão a solicitar de auxílio saúde");
        this.location.back();
      }
    }, error => {
      this.toasterService.error(error.error.message)
    })
  }

  loadDados() {
    this.exibirTipoSolicitacao = true;
    this.solicitacaoAuxSaudeService.getDadosPessoais().subscribe(result => {
      this.form.get('cargo').setValue(result.cargo)
      this.form.get('celular').setValue(result.celular)
      this.form.get('nome').setValue(result.nome)
      this.form.get('telefone').setValue(result.telefone)
      this.form.get('vinculo').setValue(result.vinculo)
      this.form.get('cpf').setValue(result.cpf)
      this.form.get('dataNascimento').setValue(result.dataNascimento)
      let cpf
      if (typeof result.cpf === 'number') {
        cpf = result.cpf.toString()
        if (cpf.length === 10) {
          cpf = '0' + cpf
          this.form.get('cpf').setValue(cpf)
        }
      }
    }, error => {
      this.toasterService.error(error.error.message)
    })

    this.solicitacaoAuxSaudeService.getTipoSolicitacao().subscribe(result => {
      this.listaTipoSolicitacao = result;
    }, error => {
      this.toasterService.error(error.error.message)
    })


  }

  validarListaRequisicao(lista) {
    this.listaRequisicaoValidada = lista.some((item) => {
      if (item.dependente === "Não") {
        return true;
      }
      return false;
    })
  }

  voltar() {
    this.location.back();
  }

  submit() {
    if (this.listaRequisicaoValidada) {
      this.solicitacaoAuxSaudeService.submit(this.solicitacaoId).subscribe(result => {
        this.toasterService.success("Solicitação realizada com sucesso")
        this.location.back();
      }, error => {
        this.toasterService.error(error.error.message)
      })
    }
    else {
      this.toasterService.warning("É necessário haver pelo menos um requerimento referente ao titular")
    }
  }

  setIdNovaSolicitacao(idNovaSolicitacao) {
    this.solicitacaoId = idNovaSolicitacao;
  }
}
